import { CometUserRoleType } from '@zg-rentals/rental-manager-env';

const userUtils = {
  isPostingPathAdmin(roleTypes: Array<CometUserRoleType> = []) {
    if (roleTypes === null) {
      return false;
    }

    return roleTypes.includes(CometUserRoleType.POSTING_PATH_ADMIN);
  },
  isRocketshipCustomer(roleTypes: Array<CometUserRoleType> = []) {
    return roleTypes.includes(CometUserRoleType.ROCKET_SHIP_CUSTOMER);
  },
  isNucleusCustomer(roleTypes: Array<CometUserRoleType> = []) {
    return roleTypes.includes(CometUserRoleType.NUCLEUS_CUSTOMER);
  },
  isSingleFamilyPayPerListingCustomer(roleTypes: Array<CometUserRoleType> = []) {
    return roleTypes.includes(CometUserRoleType.SINGLE_FAMILY_LEGACY);
  },
  isCompanyAdmin(roleTypes: Array<CometUserRoleType> = []) {
    return roleTypes.includes(CometUserRoleType.PROPERTY_MANAGER_COMPANY_ADMIN);
  },
  getFeaturePermissions(roleTypes: Array<CometUserRoleType> = []) {
    const isAdmin = roleTypes.includes(CometUserRoleType.PROPERTY_MANAGER_COMPANY_ADMIN);
    const enabledPermissions = {
      ADD_LISTING: isAdmin || roleTypes.includes(CometUserRoleType.PROPERTY_MANAGER_ADD_PROPERTY),
      UPDATE_LISTING: isAdmin || roleTypes.includes(CometUserRoleType.PROPERTY_MANAGER_UPDATE_LISTING),
      VIEW_INVOICE: isAdmin || roleTypes.includes(CometUserRoleType.PROPERTY_MANAGER_VIEW_INVOICE),
      VIEW_CONTACT: isAdmin || roleTypes.includes(CometUserRoleType.PROPERTY_MANAGER_VIEW_MESSAGE),
      RESPOND_REVIEW: isAdmin || roleTypes.includes(CometUserRoleType.PROPERTY_MANAGER_RESPOND_TO_REVIEW),
      VIEW_ANALYTICS: isAdmin || roleTypes.includes(CometUserRoleType.PROPERTY_MANAGER_VIEW_ANALYTICS),
      COMPANY_ADMIN: isAdmin,
      SYNC_PROPERTIES: isAdmin || roleTypes.includes(CometUserRoleType.PROPERTY_MANAGER_ALL_PROPERTIES),
      COMPANY_USER: !isAdmin,
    };
    return enabledPermissions;
  },
};

export default userUtils;
